import { useEffect, useState } from "react";
import {
  fetchServiceIndividualInventorySnapshot,
  InventorySnapshotResponse,
  ServiceIndividualFilterParams,
} from "../services/serviceIndividualDashboardApi";

interface ServiceIndividualInventorySnapshotState {
  data: InventorySnapshotResponse | null;
  isLoading: boolean;
  error: string | null;
}

const getErrorMessage = (error: unknown): string => {
  if (error instanceof Error) return error.message;
  return "Failed to load Inventory Snapshot.";
};

export const useServiceIndividualInventorySnapshot = (
  filters: ServiceIndividualFilterParams,
  enabled: boolean,
  refreshKey = 0,
): ServiceIndividualInventorySnapshotState => {
  const [state, setState] = useState<ServiceIndividualInventorySnapshotState>({
    data: null,
    isLoading: false,
    error: null,
  });

  useEffect(() => {
    if (!enabled) return;
    if (filters.period === "custom" && (!filters.from_date || !filters.to_date)) {
      return;
    }

    let isCurrent = true;

    setState((current) => ({
      ...current,
      isLoading: true,
      error: null,
    }));

    fetchServiceIndividualInventorySnapshot(filters)
      .then((data) => {
        if (!isCurrent) return;
        setState({ data, isLoading: false, error: null });
      })
      .catch((error) => {
        if (!isCurrent) return;
        setState((current) => ({
          ...current,
          isLoading: false,
          error: getErrorMessage(error),
        }));
      });

    return () => {
      isCurrent = false;
    };
  }, [enabled, filters.period, filters.from_date, filters.to_date, refreshKey]);

  return state;
};
